export var TimeoutType;
(function (TimeoutType) {
    TimeoutType[TimeoutType["Absolute"] = 1] = "Absolute";
    TimeoutType[TimeoutType["Refresh"] = 2] = "Refresh";
})(TimeoutType || (TimeoutType = {}));
